import React from 'react';

const Boton = ({funcion, texto}) => {

    return (
        <React.Fragment>
            <button className="text-[13px] md:text-sm leading-4 rounded-md inline-flex items-center cursor-pointer transition ease-in-out duration-300 font-semibold font-body text-center justify-center border-0 border-transparent placeholder-white focus-visible:outline-none focus:outline-none  bg-customRed text-white px-5 md:px-6 lg:px-8 py-4 md:py-3.5 lg:py-4 hover:text-white hover:opacity-45 hover:shadow-cart h-10 mt-1 text-sm lg:text-base w-full"
                type="submit"
                onClick={funcion}
            >
                {texto}
            </button>
        </React.Fragment>
    );
}

export default Boton;